import { Injectable } from '@angular/core';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { Observable, of } from 'rxjs';

@Injectable()
export class InstallationIncotermsPluginService extends InspectionPluginService {
  private incotermsKeys = [
    { value: 1, label: 'plugins.installationincoterms.exw' },
    { value: 2, label: 'plugins.installationincoterms.fca' },
    { value: 3, label: 'plugins.installationincoterms.fob' },
    { value: 4, label: 'plugins.installationincoterms.cpt' },
    { value: 5, label: 'plugins.installationincoterms.cip' },
    { value: 6, label: 'plugins.installationincoterms.cfr' },
    { value: 7, label: 'plugins.installationincoterms.cif' },
    { value: 8, label: 'plugins.installationincoterms.ddp' },
    { value: 9, label: 'plugins.installationincoterms.dap' },
    { value: 10, label: 'plugins.installationincoterms.dpu' },
    { value: 0, label: 'plugins.installationincoterms.empty' }
  ];

  private incoterms = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getIncoterms() {
    return this.incoterms;
  }

  public updateIncoterms(inspectionId: string, pointId: string, pluginId: string, incoterms: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, incoterms).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.incoterms = [];
    this.copyTranslationValues(this.incotermsKeys, this.incoterms, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, incoterms: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, incoterms, 'Incoterms').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
